import { cn } from 'components/UI/cn'
import { chartTheme } from './chart-theme'

/**
 * Linear progress bar (TailGrids "Steps3"/core Progress), themed. A rounded
 * track with a filled bar; `withLabel` appends the percentage on the right.
 * `barColor` overrides the default brand fill (e.g. to tint per category).
 */
export function ProgressBar({
  value,
  withLabel = false,
  barColor,
  className,
}: {
  /** 0–100. */
  value: number
  withLabel?: boolean
  barColor?: string
  className?: string
}) {
  const pct = Math.max(0, Math.min(100, value))
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <div className="h-2 flex-1 overflow-hidden rounded-full bg-neutral-100">
        <div
          className="h-full rounded-full"
          style={{
            width: `${pct}%`,
            backgroundColor: barColor ?? chartTheme.primary,
          }}
        />
      </div>
      {withLabel && (
        <span className="shrink-0 text-sm font-medium text-fg-secondary">
          {pct}%
        </span>
      )}
    </div>
  )
}
